import React from 'react'
import PageBlocks from '../cms-page-blocks/list'

const ContactPageBlockEditor = (props) => {
  return (
    <PageBlocks
      title='Contact Page Blocks'
      target='cms_fixed_page_blocks'
      cmsPageProp='page'
      cmsPageId='contact_page'
      route={props.route}
    />
  )
}

export default ContactPageBlockEditor
